import { render, staticRenderFns } from "./ArtistProfile.vue?vue&type=template&id=4f94edb4&"
import script from "./ArtistProfile.vue?vue&type=script&lang=js&"
export * from "./ArtistProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports